/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import {
  Button,
  Card,
  Checkbox,
  CircularProgress,
  FormControl,
  FormGroup,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Tooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import profileIcon from "assets/images/Profile-1.svg";
import profileIconDark from "assets/images/Profile.svg";
import MDBadge from "components/MDBadge";
import { useMaterialUIController } from "context";
import { CloseRounded, RemoveRedEyeOutlined } from "@mui/icons-material";
import MDButton from "components/MDButton";
import { GetProductionRequests, UpdateProductionAPIStatus } from "api-services";
import moment from "moment/moment";
import PropTypes from "prop-types";
import { CSVLink } from "react-csv";
import { ShowSuccessMessage } from "helpers";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
import SendEmail from "../users/components/send_email_modal";
import "../users/components/css/send_email.css";
import "../users/users.css";
import RecentEmail from "../users/components/recent_email_modal";
import "../users/components/css/recent_email.css";

const Author = ({ name, email }) => (
  <MDBox display="flex" alignItems="center" lineHeight={1}>
    <MDBox lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
      <MDTypography variant="caption">{email}</MDTypography>
    </MDBox>
  </MDBox>
);

const Job = ({ title }) => (
  <MDBox lineHeight={1} textAlign="left">
    <MDTypography
      display="block"
      variant="caption"
      color="text"
      fontWeight="medium"
    >
      {title}
    </MDTypography>
  </MDBox>
);

const Products = ({ myAPI }) => {
  myAPI = myAPI.sort((a, b) => (a.name > b.name ? 1 : -1));
  return (
    <MDBox sx={{ display: "flex", flexDirection: "column" }}>
      {myAPI.map((item) => (
        <MDBadge
          key={item?.apiid}
          badgeContent={item?.name}
          sx={{ marginBottom: "5px" }}
          color={getProductBadgeColor(item?.apiid)}
          variant="gradient"
          size="sm"
        />
      ))}
    </MDBox>
  );
};

const getProductBadgeColor = (id) => {
  return "light";
};

const CustomCheckBox = ({ product, handleProductChange }) => {
  const [checked, setChecked] = useState(true);
  const handleChange = (id, value) => {
    handleProductChange(id, value);
    setChecked(value);
  };
  return (
    <MDBox sx={{ display: "flex" }}>
      <Checkbox
        checked={checked}
        onChange={(e) => handleChange(product?.apiid, e.target.checked)}
      />
      {/* <Checkbox checked={checked} onChange={(e) => setChecked(!checked)} /> */}
      <MDTypography variant="subtitle2" mt={0.6}>
        {product?.name}
      </MDTypography>
    </MDBox>
  );
};

function AccessRequests() {
  const [rows, setRows] = useState([]);

  const [controller, dispatch] = useMaterialUIController();
  const { darkMode } = controller;

  const [selectedItem, setSelectedItem] = useState();

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setError("");
    setSuccess(false);
    setFailed(false);
    setOpen(false);
  };

  const { loading } = useSelector((state) => state.products);

  const dispatchData = useDispatch();

  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [failed, setFailed] = useState(false);
  const userFilterFetch = window.location.hash.substring(1);

  const { user_data } = useSelector((state) => state.authentication);

  const getUserStatus = (userFilterFetch) => {
    if (userFilterFetch === "") return "all";
    switch (userFilterFetch) {
      case "ALL":
        return "all";
      case "A":
        return "A";
      case "P":
        return "P";
      case "R":
        return "R";
      case "W":
        return "W";
      case "I":
        return "I";
      default:
        return "all";
    }
  };

  const [selectedTab, setSelectedTab] = useState(
    getUserStatus(userFilterFetch)
  );
  const [statusValue, setStatusValue] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [priviousStatus, setPriviousStatus] = useState("");

  // Update Status
  const [firmUserBelongsTo, setFirmUserBelongsTo] = useState("");
  const [boothId, setBoothId] = useState("");
  const [correspondentCode, setCorrespondentCode] = useState("");
  const [office, setOffice] = useState("");
  const [clientId, setClientId] = useState("");
  const [nameTrd, setNameTrd] = useState("");
  const [valueTrd, setValueTrd] = useState("");
  const [boothTrd, setBoothTrd] = useState("");

  const [firmFnd, setFirmFnd] = useState("");

  //Download
  const [downloadData, setDownloadData] = useState(null);

  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [openRecentEmailModal, setOpenRecentEmailModal] = useState(false);

  useEffect(() => {
    GetProductionRequests(
      dispatchData,
      successAction,
      errorAction,
      "",
      selectedTab
    );
  }, []);

  let bgColor = darkMode ? "#1a2035" : "#fff";

  const validateCheckBoxes = () => {
    let flag = false;
    selectedItem?.myAPI?.forEach((item) => {
      if (item.checked) {
        flag = true;
      }
    });

    return flag;
  };

  //Send Email Modal
  const handleSendEmail = (item) => {
    setSelectedItem(item);
    setOpenEmailModal(true);
  };

  const handleCloseEmailModal = () => {
    setOpenEmailModal(false);
  };

  //Recent Email Modal
  const handleRecentEmail = (item) => {
    setSelectedItem(item);
    setOpenRecentEmailModal(true);
  };

  const handleCloseRecentEmailModal = () => {
    setOpenRecentEmailModal(false);
  };

  // Get Sandbox Previous Status
  const prvStatusSandbox = priviousStatus?.myAPI
    ?.filter((i) => i.checked)
    ?.map((item) => {
      return item.status;
    });

  //Get Sandbox API Name
  const apiName = priviousStatus?.myAPI
    ?.filter((i) => i.checked)
    ?.map((item) => {
      if (item.status?.includes(statusValue)) {
        return item.name;
      }
    });

  const handleSubmit = () => {
    setError("");
    setSuccess(false);
    setFailed(false);

    if (!statusValue) {
      setError("Status cannot be empty!");
    } else if (!validateCheckBoxes()) {
      setError("At least 1 product must be selected!");
    } else if (prvStatusSandbox?.includes(statusValue)) {
      setError(
        `${apiName.toString().replace(/,/g, " - ")} - status is already ${
          (statusValue === "A" && "Approved") ||
          (statusValue === "P" && "Pending") ||
          (statusValue === "R" && "In Review") ||
          (statusValue === "W" && "Reject")
        }`
      );
    } else {
      let productsData = (selectedItem?.myAPI || [])
        .filter((i) => i.checked)
        .map((item) => {
          return {
            identifier: item.identifier,
            status: item.newStatus,
            accessType: item?.access_type,
            firmUserBelongsTo:
              firmUserBelongsTo == "" ? "Default" : firmUserBelongsTo,
            boothId: boothId == "" ? "Default" : boothId,
            correspondentCode:
              correspondentCode == "" ? "Default" : correspondentCode,
            office: office == "" ? "Default" : office,
            clientId: clientId,
            name: nameTrd,
            value: valueTrd,
            booth: boothTrd,
            firm: firmFnd,
          };
        });
      const data = {
        products: productsData,
      };
      // if (statusValue != priviousStatus) { //Only work when status is changed
      UpdateProductionAPIStatus(
        dispatchData,
        data,
        () => {
          GetProductionRequests(
            dispatchData,
            successAction,
            errorAction,
            "",
            selectedTab
          );
          setSuccess(true);
          setTimeout(() => {
            handleClose();
            setError(false);
            setSuccess(false);
            setFailed(false);
          }, 1000);
        },
        () => {
          setFailed(true);
        },
        clearFields
      );
      // }
    }
  };

  const handleTabChange = (tab) => {
    setDataLoading(true);
    setSelectedTab(tab);
    GetProductionRequests(dispatchData, successAction, errorAction, "", tab);
  };

  const handleCheckboxChanged = (id, value) => {
    if (selectedItem) {
      const products = selectedItem.myAPI.map((item) => {
        if (item.apiid == id) {
          item.checked = value;
        }

        return item;
      });
      setSelectedItem({ ...selectedItem, myAPI: products });
      updateAPIStatuses(statusValue);
    }
  };

  const updateAPIStatuses = (status) => {
    if (selectedItem) {
      const products = selectedItem.myAPI.map((item) => {
        // Update newStatus based on whether item.checked is true
        item.newStatus = item.checked ? status : item.status;
        return item;
      });
      setSelectedItem({ ...selectedItem, myAPI: products });
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "20%",
    bgcolor: bgColor,
    borderRadius: 2,
    border: 1,
    borderColor: bgColor,
    boxShadow: 100,
    p: 0,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 5,

    modal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },

    noncutomer: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "20%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },

    createModal: {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "40%",
      bgcolor: bgColor,
      borderRadius: 2,
      border: 1,
      borderColor: bgColor,
      boxShadow: 100,
      p: 0,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      padding: 5,
    },

    createModalHeader: {
      display: "flex",
      flexDirection: "row",
      alignContent: "center",
      justifyContent: "space-between",
    },
  };

  const columns = [
    { Header: "name", accessor: "name", width: "35%", align: "left" },
    { Header: "company name", accessor: "company_name", align: "left" },
    { Header: "company website", accessor: "company_website", align: "left" },
    { Header: "job role", accessor: "job_role", align: "left" },
    { Header: "product name", accessor: "requested_products", align: "left" },
    {
      Header: "Production status",
      accessor: "status",
      align: "left",
      width: "15%",
    },
    {
      Header: "registered on",
      accessor: "registered_on",
      align: "center",
      width: "12%",
    },
    { Header: "action", accessor: "action", align: "center" },
  ];

  function getDataForDownload(userData) {
    setDownloadData(null);

    const csvData = userData.map((user) => {
      // Aggregate API names and their statuses
      const apiDetails = user.myAPI.map((api) => ({
        name: api.name ? api.name : "N/A",
        status: getAPIStatus(api.status), // Use getAPIStatus to get the status description
      }));

      // Create strings for API names and statuses
      const apiNames = apiDetails.map((api) => api.name).join(", ");
      const apiStatuses = apiDetails.map((api) => api.status).join(", ");

      return {
        Name: user.fullName,
        "Company Name": user.companyName ? user.companyName : "N/A",
        "Company Website": user.companyWebSite ? user.companyWebSite : "N/A",
        "Job Role": user.jobRole ? user.jobRole : "N/A",
        "Product Name": apiNames,
        "Production Status": apiStatuses,
        "Registered On": moment(user.createdOn).format("MM/DD/yyyy"),
      };
    });

    setDownloadData(csvData);
  }

  const successAction = (res) => {
    setDataLoading(false);
    getDataForDownload(res.data);
    const allUsers = res.data.map((item) => {
      const fullName = getFullName(item.firstName, item.lastName);
      const companyName = item.companyName || "N/A";
      const companyWebSite = item.companyWebSite || "N/A";
      const apiStatusDescription =
        item?.myAPI?.length > 0 ? item.myAPI[0]?.apiStatusDes : "Pending";
      const apiStatus = item?.myAPI?.length > 0 ? item.myAPI[0]?.status : "P";

      return {
        name: (
          <Author
            image={darkMode ? profileIcon : profileIconDark}
            name={fullName}
            email={item.email}
          />
        ),
        company_name: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {companyName}
          </MDTypography>
        ),
        company_website: (
          <MDTypography
            component="a"
            href={companyWebSite !== "N/A" ? "https://" + companyWebSite : ""}
            rel="noreferrer"
            target="_blank"
            variant="caption"
            color="text"
            fontWeight="medium"
          >
            {companyWebSite}
          </MDTypography>
        ),
        job_role: <Job title={item.jobRole} />,
        requested_products: <Products myAPI={item?.myAPI} />,
        status: (
          <MDBox sx={{ display: "flex", flexDirection: "column" }}>
            <MDBadge
              badgeContent={apiStatusDescription}
              color={getBadgeColor(apiStatus)}
              variant="gradient"
              size="sm"
            />
          </MDBox>
        ),
        registered_on: (
          <MDTypography variant="caption" color="text" fontWeight="medium">
            {moment(item.createdOn).format("MM/DD/yyyy")}
          </MDTypography>
        ),
        action: (
          <div className="action-gap">
            <Button
              sx={{
                textTransform: "uppercase",
                borderRadius: "4px",
                color: "white !important",
                fontSize: "11px",
                background: "#022DEC!important",
              }}
              variant="contained"
              size="small"
              onClick={() => handleChangeStatus(item)}
            >
              Change Status
            </Button>
            <Tooltip
              title="Send Email"
              placement="bottom"
              className="custom-tooltip"
            >
              <Button
                sx={{
                  textTransform: "uppercase",
                  borderRadius: "4px",
                  color: "white !important",
                  fontSize: "11px",
                  background: "#022DEC!important",
                    "&:hover": {
                    background: "#022DEC!important",
                  }
                }}
                variant="contained"
                size="small"
                iconOnly="true"
                onClick={() => handleSendEmail(item)}
              >
                <SendOutlinedIcon />
              </Button>
            </Tooltip>
            <Tooltip title="Recent Email" placement="bottom">
              <Button
                sx={{
                  textTransform: "uppercase",
                  borderRadius: "4px",
                  fontSize: "11px",
                  color: "#000 !important",
                  background: "transparent !important",
                   "&:hover": {
                    background: "transparent !important",
                  }
                }}
                variant="contained"
                size="small"
                iconOnly="true"
                onClick={() => handleRecentEmail(item)}
              >
                <RemoveRedEyeOutlined />
              </Button>
            </Tooltip>
          </div>
        ),
      };
    });

    setRows(allUsers);
  };

  // Helper Functions
  const getFullName = (fName, lName) => {
    return fName + " " + (lName || "");
  };

  const getBadgeColor = (status) => {
    switch (status) {
      case "A":
        return "success";
      case "P":
        return "warning";
      case "R":
        return "info";
      default:
        return "error";
    }
  };

  const handleChangeStatus = (item) => {
    item.myAPI = item.myAPI.map((api) => ({
      ...api,
      checked: true,
      access_type: "Production",
      newStatus: api.status,
    }));
    setSelectedItem(item);
    setStatusValue(item?.myAPI?.length > 0 ? item.myAPI[0]?.status : "P");
    handleOpen();
    clearSelectedItemFields();
    setPriviousStatus(item);
  };
  const errorAction = () => {
    setDataLoading(false);
  };

  const clearFields = () => {
    setSelectedItem();
    setStatusValue("P");
  };

  const clearSelectedItemFields = () => {
    setFirmUserBelongsTo("");
    setBoothId("");
    setCorrespondentCode("");
    setOffice("");
    setClientId("");
    setNameTrd("");
    setValueTrd("");
    setBoothTrd("");
    setFirmFnd("");
  };

  const fName = selectedItem?.firstName;
  const lName =
    selectedItem?.lastName !== null && selectedItem?.lastName !== undefined
      ? selectedItem?.lastName
      : "";
  const fullName = fName + " " + lName;

  const getAPIStatus = (status) => {
    switch (status) {
      case "A":
        return "Approved";
      case "P":
        return "Pending";
      case "R":
        return "In Review";
      case "I":
        return "Suspended";
      case "W":
        return "Rejected";
      default:
        return "N/A";
    }
  };
  const renderExportButton = () => (
    <MDBox mr={3}>
      {(() => {
        if (
          downloadData &&
          ((Array.isArray(downloadData) && downloadData.length > 0) ||
            typeof downloadData === "string")
        ) {
          return (
            <CSVLink
              data={downloadData}
              className="white"
              asyncOnClick={false}
              filename={`Production Requests.csv`}
              onClick={handleCSVDownload}
            >
              <MDButton className="btn-spc" color="success">
                {!dataLoading ? (
                  <span>Export</span>
                ) : (
                  <CircularProgress color="white" size={22} />
                )}
              </MDButton>
            </CSVLink>
          );
        } else if (Array.isArray(downloadData) && downloadData.length === 0) {
          return <></>;
        } else {
          return (
            <MDButton
              className="btn-spc"
              color="success"
              sx={{ pointerEvents: "none" }}
            >
              <CircularProgress color="white" size={22} />
            </MDButton>
          );
        }
      })()}
    </MDBox>
  );

  const renderButtonContainer = () => (
    <Grid item xs={12} xl={10} sx={{ justifyContent: "end", display: "flex" }}>
      {renderExportButton()}
    </Grid>
  );

  const handleCSVDownload = () => {
    ShowSuccessMessage(dispatch, "Data exported successfully");
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={3} mt={2}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
                <MDBox mt={4}>
                  <Grid container>
                    <Grid item xs={12} xl={2} px={2}>
                      <FormControl fullWidth sx={{ height: "50px" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          variant="outlined"
                          color="success"
                          className="inputbox mb-2"
                        >
                          Production Status
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          value={selectedTab}
                          label="Production Status"
                          onChange={(e) => {
                            handleTabChange(e.target.value);
                          }}
                          sx={{ height: "50px" }}
                        >
                          <MenuItem value={"all"}>All</MenuItem>
                          <MenuItem value={"A"}>Approved</MenuItem>
                          <MenuItem value={"P"}>Pending</MenuItem>
                          <MenuItem value={"R"}>In Review</MenuItem>
                          <MenuItem value={"W"}>Rejected</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    {user_data?.customer?.roleId === 4 &&
                      renderButtonContainer()}
                    {user_data?.customer?.roleId === 2 &&
                      renderButtonContainer()}
                  </Grid>
                </MDBox>
              </div>
              <MDBox pt={3} pb={3} display="flex" justifyContent="center">
                {dataLoading ? (
                  <CircularProgress color="success" size={30} />
                ) : (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    entriesPerPage={true}
                    showTotalEntries={true}
                    canSearch={true}
                    noEndBorder
                    setGlobalFilterAPI={(value) => {
                      GetProductionRequests(
                        dispatchData,
                        successAction,
                        errorAction,
                        value,
                        selectedTab
                      );
                    }}
                  />
                )}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <SendEmail
        open={openEmailModal}
        handleClose={handleCloseEmailModal}
        darkMode={darkMode}
        style={style}
        selectedItem={selectedItem}
        isProduction={true}
      />
      <RecentEmail
        open={openRecentEmailModal}
        handleClose={handleCloseRecentEmailModal}
        darkMode={darkMode}
        style={style}
        selectedItem={selectedItem}
        isProduction={true}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className={darkMode ? "darkmode_wrap" : "lightmode_wrap"}>
          <MDBox sx={style}>
            <MDBox onClick={handleClose} className="close-modal-sm">
              <CloseRounded color={darkMode ? "white" : "secondary"} />
            </MDBox>
            <MDTypography variant="h5" sx={{ textTransform: "Capitalize" }}>
              {fullName}
            </MDTypography>
            <MDTypography variant="p" sx={{ fontSize: "14px" }} mb={4}>
              {selectedItem?.email}
            </MDTypography>
            {/* <MDInput type="email" label="Email Address" color="success" variant="outlined" value={emailAddress} onChange={(e) => setEmailAddress(e.target.value)} fullWidth className="inputbox mb-2" required /> */}
            <Grid container spacing={2} direction="row">
              <Grid item xs={12} lg={12}>
                <FormControl fullWidth sx={{ height: "50px" }}>
                  <InputLabel
                    id="demo-simple-select-label"
                    variant="outlined"
                    color="success"
                    className="inputbox mb-2"
                  >
                    Production Status
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={statusValue}
                    label="Production Status"
                    onChange={(e) => {
                      setStatusValue(e.target.value);
                      updateAPIStatuses(e.target.value);
                    }}
                    sx={{ height: "50px" }}
                  >
                    <MenuItem value={"A"}>Approve</MenuItem>
                    <MenuItem value={"P"}>Pending</MenuItem>
                    <MenuItem value={"R"}>In Review</MenuItem>
                    <MenuItem value={"W"}>Reject</MenuItem>
                  </Select>
                </FormControl>
                {success && (
                  <MDTypography
                    color="success"
                    variant="subtitle1"
                    sx={{ fontSize: "12px" }}
                  >
                    Status changed successfully!
                  </MDTypography>
                )}
                {failed && (
                  <MDTypography
                    color="error"
                    variant="subtitle1"
                    sx={{ fontSize: "12px" }}
                  >
                    There was an error submitted the request
                  </MDTypography>
                )}
                {error && (
                  <MDTypography
                    color="error"
                    variant="subtitle1"
                    sx={{ fontSize: "12px" }}
                    mt={1}
                  >
                    {error}
                  </MDTypography>
                )}
              </Grid>
            </Grid>
            <MDBox my={2}>
              <FormGroup>
                {" "}
                {/*className="checkbox-wrap"*/}
                {selectedItem?.myAPI.map((item) => (
                  <MDBox key={item}>
                    <CustomCheckBox
                      key={item}
                      product={item}
                      handleProductChange={(id, value) => {
                        handleCheckboxChanged(id, value);
                      }}
                    />
                  </MDBox>
                ))}
              </FormGroup>
            </MDBox>
            <MDBox
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <MDButton
                className="btn-update mt-3 px-2 py-3"
                sx={{ paddingLeft: 6.5, paddingRight: 6.5, width: "100%" }}
                variant="gradient"
                color="success"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  `Update Status`
                )}
              </MDButton>
            </MDBox>
          </MDBox>
        </div>
      </Modal>
    </DashboardLayout>
  );
}
Author.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
};
Job.propTypes = {
  title: PropTypes.string.isRequired,
};
Products.propTypes = {
  myAPI: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
CustomCheckBox.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  handleProductChange: PropTypes.func.isRequired,
};
CustomCheckBox.propTypes = {
  product: PropTypes.shape({
    apiid: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  handleProductChange: PropTypes.func.isRequired,
};
export default AccessRequests;
